import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import PowertrainConfigurationComponent from './PowertrainConfigurationComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import { getSiteIds, getOrganizationIds } from './helpers';
import './style.scss';


const PowertrainConfigurationContainer = (props) => {
    const {
        generalFilterLoadingStatuses,
        organizations,
        selectedSites,
        hierarchyDataLoadingStatus,
        hierarchyData,
        powertrainsLoadingStatus
    } = props.model;

    const {
        initializeDataRequest,
        setIsEditHierarchy,
        clearStore
    } = props.actions;

    const organizationID = organizations?.[0]?.organizationID;

    useEffect(() => {
        return () => {
            clearStore();
        };
    }, []);

    useEffect(() => {
        if (organizationID) {
            const siteIds = getSiteIds(selectedSites);
            const organizationIds = getOrganizationIds(organizations);
            initializeDataRequest(organizationID, siteIds, organizationIds);
            setIsEditHierarchy(false);
        }
    }, [organizationID, JSON.stringify(selectedSites), initializeDataRequest, setIsEditHierarchy]);

    return <LoadingStatusWrapper
        loadingStatus={[...generalFilterLoadingStatuses, hierarchyDataLoadingStatus, powertrainsLoadingStatus]}
    >
        {Object.keys(hierarchyData).length > 0 && <PowertrainConfigurationComponent {...props} />}
    </LoadingStatusWrapper >;
};

PowertrainConfigurationContainer.propTypes = {
    model: PropTypes.shape({
        generalFilterLoadingStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
        organizations: PropTypes.arrayOf(PropTypes.shape({
            organizationID: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })).isRequired,
        selectedSites: PropTypes.arrayOf(PropTypes.shape({
            siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })).isRequired,
        hierarchyDataLoadingStatus: PropTypes.string,
        hierarchyData: PropTypes.object.isRequired,
        powertrainsLoadingStatus: PropTypes.string
    }).isRequired,
    actions: PropTypes.shape({
        initializeDataRequest: PropTypes.func.isRequired,
        setIsEditHierarchy: PropTypes.func.isRequired,
        clearStore: PropTypes.func.isRequired
    }).isRequired
};


const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const PowertrainConfigurationContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(PowertrainConfigurationContainer);

export default PowertrainConfigurationContainerConn;
